let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dzydr")).then(() => parcelRequire('5NWfS'));